import { render, staticRenderFns } from "./foot-cart-item.vue?vue&type=template&id=86410a1a&scoped=true&"
import script from "./foot-cart-item.vue?vue&type=script&lang=js&"
export * from "./foot-cart-item.vue?vue&type=script&lang=js&"
import style0 from "./foot-cart-item.vue?vue&type=style&index=0&id=86410a1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86410a1a",
  null
  
)

export default component.exports